
import hasPageMeta from '@/mixins/hasPageMeta'
import { mapState } from 'vuex'
export default {
    mixins: [hasPageMeta],

    async fetch() {
        try {
            await this.$store.dispatch('jsonloader/fetchJson', 'guides-' + this.$route.params.guide + '.json')
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('Failed loading content: ', e)
        }
    },

    computed: {
        ...mapState({
            jsonContent(state) {
                const key = 'guides-' + this.$route.params.guide + '.json'
                return state.jsonloader.data[key] || {}
            },
        }),

        isContentValid() {
            return Object.keys(this.jsonContent).length > 0
        },

        jsonMeta() {
            return this.jsonContent?.meta || {}
        },

        siteTitle() {
            return `${this.jsonMeta?.title || ''}`
        },

        siteDescription() {
            return this.jsonMeta?.excerpt || 'Wondering how to plan your own wedding? Our guides will walk you through the every step of the planning process.'
        },

        previewImage() {
            return this.jsonMeta?.image || `${process.env.baseUrl}/guides/landing/hero.jpg`
        },

        jsonHero() {
            return this.jsonContent?.hero || {}
        },
    },
}
